import { BrowserRouter, Routes, Route } from "react-router-dom";

import Authlogin from "./pages/auth/login.js";
import ChangeMyPassword from "./pages/profile/changemypassword.js";
//import ManageMachine from "./pages/machine/managemachine.js";
import ManageUser from "./pages/settings/user/manageuser.js";
import ManageSupplier from "./pages/settings/supplier/managesupplier.js";
import AgroDashboard from './pages/dashboard/agrodashboard.js';
import ResetPassword from "./pages/auth/resetpassword.js";
// import CreateTask from "./pages/tasks/createtask.js";
// import TaskList from "./pages/tasks/taskList.js";
// import TodoDetailPage from "./pages/tasks/taskDetails.js";
// import CompletedTasksHistory from "./pages/tasks/taskhistorybydate.js";
// import TaskDetailViewPage from "./pages/tasks/taskdetailview.js";
// import TodoBoardPage  from "./pages/tasks/todoboard.js";
// import TodoHistoryReport from './pages/reports/todoHistoryReport.js';

// Security
import ManageRoles from './pages/settings/security/manageroles.js';

// Phase 1 — Reference Data
import ManagePlantCategory from './pages/settings/plantcategory/manageplantcategory.js';
import ManageSalesProductCategory from './pages/settings/salesproductcategory/managesalesproductcategory.js';
import ManageMaintainCategory from './pages/settings/maintaincategory/managemaintaincategory.js';
import ManageUom from './pages/settings/uom/manageuom.js';
import ManageExpenseCategory from './pages/settings/expensecategory/manageexpensecategory.js';
import ManagePaymentAccount from './pages/settings/paymentaccount/managepaymentaccount.js';
import ManageCustomerArea from './pages/settings/customerarea/managecustomerarea.js';
import ManageHarvestSeason from './pages/settings/harvestseason/manageharvestseason.js';

// Customers
import ManageCustomer from './pages/customers/managecustomer.js';

// Sales Products
import ManageSalesProducts from './pages/salesproducts/managesalesproducts.js';

// Phase 2 — Core Hierarchy
import ManageLand from './pages/farmSetUp/land/manageland.js';
import ManageSection from './pages/farmSetUp/section/managesection.js';
import ManageFields from './pages/farmSetUp/fields/managefields.js';

// Phase 3 — Plant Tracking
import ManagePlants from './pages/farmSetUp/plant/manageplants.js';

// Phase 4 — Maintenance
import ManageMaintenance from './pages/maintenance/managemaintenance.js';
import AddMaintenance from './pages/maintenance/addmaintenance.js';

// Inventory Management
import ManageInventoryCategory from './pages/inventory/category/manageinventorycategory.js';
import ManageInventoryItems from './pages/inventory/items/manageinventoryitems.js';
import ManageInventoryAdjustments from './pages/inventory/adjustments/manageinventoryadjustments.js';
import ManagePurchaseRequests from './pages/inventory/pr/ManagePurchaseRequests.js';
import CreatePR from './pages/inventory/pr/CreatePR.js';
import ManagePRItems from './pages/inventory/pr/ManagePRItems.js';
import ViewPR from './pages/inventory/pr/ViewPR.js';
import PRApprovals from './pages/inventory/pr/PRApprovals.js';
import PRApprovalDetail from './pages/inventory/pr/PRApprovalDetail.js';

// Goods Received Notes (GRN)
import ManageGRN from './pages/inventory/grn/ManageGRN.js';
import CreateGRN from './pages/inventory/grn/CreateGRN.js';
import ReceiveGRNItems from './pages/inventory/grn/ReceiveGRNItems.js';
import ViewGRN from './pages/inventory/grn/ViewGRN.js';
import GRNApprovals from './pages/inventory/grn/GRNApprovals.js';
import GRNApprovalDetail from './pages/inventory/grn/GRNApprovalDetail.js';

// Material Requests
import RequestList from './pages/inventory/material_request/RequestList.js';
import CreateRequest from './pages/inventory/material_request/CreateRequest.js';
import ManageRequestItems from './pages/inventory/material_request/ManageRequestItems.js';
import ViewRequest from './pages/inventory/material_request/ViewRequest.js';
import RequestApproval from './pages/inventory/material_request/RequestApproval.js';
import RequestApprovalDetail from './pages/inventory/material_request/RequestApprovalDetail.js';
import RequestAcceptList from './pages/inventory/material_request/RequestAcceptList.js';
import RequestAccept from './pages/inventory/material_request/RequestAccept.js';

// Inventory Issuing (Material Issue Note)
import IssueingList from './pages/inventory/issuing/IssueingList.js';
import PrepareItems from './pages/inventory/issuing/PrepareItems.js';
import ReadyItems from './pages/inventory/issuing/ReadyItems.js';
import IssueItems from './pages/inventory/issuing/IssueItems.js';
import ViewIssueNote from './pages/inventory/issuing/ViewIssueNote.js';

// Expenses
import ExpenseList from './pages/expenses/ExpenseList.js';
import ApproveExpenses from './pages/expenses/ApproveExpenses.js';
import CreatePayment from './pages/expenses/CreatePayment.js';
import PaymentSettle from './pages/expenses/PaymentSettle.js';

// Reports
import AllReports from './pages/reports/AllReports.js';
import InventoryItemsReport from './pages/reports/inventory/InventoryItemsReport.js';
import StockAdjustmentsReport from './pages/reports/inventory/StockAdjustmentsReport.js';
import PurchaseRequestsReport from './pages/reports/inventory/PurchaseRequestsReport.js';
import GrnReport from './pages/reports/inventory/GrnReport.js';
import MaterialRequestsReport from './pages/reports/inventory/MaterialRequestsReport.js';
import IssueNotesReport from './pages/reports/inventory/IssueNotesReport.js';
import StockValuationReport from './pages/reports/inventory/StockValuationReport.js';
import LowStockReport from './pages/reports/inventory/LowStockReport.js';
import MaintenanceTasksReport from './pages/reports/maintenance/MaintenanceTasksReport.js';
import ExpensesReport from './pages/reports/expenses/ExpensesReport.js';
import CashFlowReport from './pages/reports/expenses/CashFlowReport.js';
import PaymentsReport from './pages/reports/expenses/PaymentsReport.js';
import PlantsReport from './pages/reports/farm/PlantsReport.js';

// Harvesting
import ManageHarvestBatches from './pages/harvesting/harvestbatch/ManageHarvestBatches.js';
import HarvestBatchDetail from './pages/harvesting/harvestbatch/HarvestBatchDetail.js';
import HarvestCollection from './pages/harvesting/harvestcollection/HarvestCollection.js';
import HarvestCollectionDetail from './pages/harvesting/harvestcollection/HarvestCollectionDetail.js';

// Production
import ManageProductionBatches from "./pages/production/productionbatch/ManageProductionBatches.js";
import ProductionBatchDetail from "./pages/production/productionbatch/ProductionBatchDetail.js";
import ProductionProcess from "./pages/production/productionprocess/ProductionProcess.js";
import ProductionProcessDetail from "./pages/production/productionprocess/ProductionProcessDetail.js";
import ProductionLogs from "./pages/production/productionlogs/ProductionLogs.js";

// System Visualizer
import SystemVisualizer from './pages/farmSetUp/overview/systemvisualizer.js';

// Access Control
import PermissionRoute from './components/common/PermissionRoute.js';
import AccessDenied from './pages/accessdenied.js';
import { REPORT_PERMISSION_KEYS } from './utils/permissionHelper.js';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Authlogin />} />
        <Route path="/login" element={<Authlogin />} />
        <Route path="/dash" element={<AgroDashboard />} />
        <Route path="/updatepassword" element={<ChangeMyPassword />} />
        <Route path="/usermanagement" element={<PermissionRoute permKey="settings_users"><ManageUser /></PermissionRoute>} />
        <Route path="/suppliermanagement" element={<PermissionRoute permKey="settings_suppliers"><ManageSupplier /></PermissionRoute>} />

        <Route path="/resetpassword" element={<ResetPassword />} />

        {/* <Route path="/createtask" element={<CreateTask />} />
        <Route path="/taskList" element={<TaskList />} />
        <Route path="/tododetail/:id" element={<TodoDetailPage />} />
        <Route path="/taskhistorybydate" element={<CompletedTasksHistory />} />
        <Route path="/tododetailview/:id" element={<TaskDetailViewPage />} />
        <Route path="/todoboard" element={<TodoBoardPage />} />
        <Route path="/todohistoryreport" element={<TodoHistoryReport />} /> */}

        {/* Security */}
        <Route path="/manageroles" element={<PermissionRoute permKey="settings_rolePermissions"><ManageRoles /></PermissionRoute>} />

        {/* Phase 1 — Reference Data */}
        <Route path="/plant-category" element={<PermissionRoute permKey="settings_plantCategories"><ManagePlantCategory /></PermissionRoute>} />
        <Route path="/sales-product-categories" element={<PermissionRoute permKey="settings_salesProductCategories"><ManageSalesProductCategory /></PermissionRoute>} />
        <Route path="/maintain-category" element={<PermissionRoute permKey="settings_maintenanceCategories"><ManageMaintainCategory /></PermissionRoute>} />
        <Route path="/uom" element={<PermissionRoute permKey="settings_uoms"><ManageUom /></PermissionRoute>} />
        <Route path="/expense-category" element={<PermissionRoute permKey="settings_expenseCategories"><ManageExpenseCategory /></PermissionRoute>} />
        <Route path="/payment-accounts" element={<PermissionRoute permKey="settings_paymentAccounts"><ManagePaymentAccount /></PermissionRoute>} />
        <Route path="/customer-areas" element={<PermissionRoute permKey="settings_customerAreas"><ManageCustomerArea /></PermissionRoute>} />
        <Route path="/harvest-seasons" element={<PermissionRoute permKey="settings_harvestseasons"><ManageHarvestSeason /></PermissionRoute>} />

        {/* Customers */}
        <Route path="/customers" element={<PermissionRoute permKey="customers_list"><ManageCustomer /></PermissionRoute>} />

        {/* Sales Products */}
        <Route path="/sales-products" element={<PermissionRoute permKey="sales_products_list"><ManageSalesProducts /></PermissionRoute>} />

        {/* Phase 2 — Core Hierarchy */}
        <Route path="/land" element={<PermissionRoute permKey="farmSetUp_manageLands"><ManageLand /></PermissionRoute>} />
        <Route path="/section" element={<PermissionRoute permKey="farmSetUp_manageSections"><ManageSection /></PermissionRoute>} />
        <Route path="/fields" element={<PermissionRoute permKey="farmSetUp_manageFields"><ManageFields /></PermissionRoute>} />

        {/* Phase 3 — Plant Tracking */}
        <Route path="/plants" element={<PermissionRoute permKey="farmSetUp_managePlants"><ManagePlants /></PermissionRoute>} />

        {/* Harvesting */}
        <Route path="/harvesting/harvest-batches" element={<PermissionRoute permKey="harvesting_harvest_batches_view"><ManageHarvestBatches /></PermissionRoute>} />
        <Route path="/harvesting/harvest-batches/:id" element={<PermissionRoute permKey="harvesting_harvest_batches_view_details"><HarvestBatchDetail /></PermissionRoute>} />
        <Route path="/harvesting/harvest-collection" element={<PermissionRoute permKey="harvesting_management"><HarvestCollection /></PermissionRoute>} />
        <Route path="/harvesting/harvest-collection/:id" element={<PermissionRoute permKey="harvesting_management"><HarvestCollectionDetail /></PermissionRoute>} />

        {/* Production */}
        <Route path="/production/production-batches" element={<PermissionRoute permKey="prod_batches_view"><ManageProductionBatches /></PermissionRoute>} />
        <Route path="/production/production-batches/:id" element={<PermissionRoute permKey="prod_batches_details"><ProductionBatchDetail /></PermissionRoute>} />
        <Route path="/production/production-process" element={<PermissionRoute permKey="prod_process_view"><ProductionProcess /></PermissionRoute>} />
        <Route path="/production/production-process/:id" element={<PermissionRoute permKey="prod_process_view"><ProductionProcessDetail /></PermissionRoute>} />
        <Route path="/production/production-logs" element={<PermissionRoute permKey="prod_logs_view"><ProductionLogs /></PermissionRoute>} />

        {/* Maintenance */}
        <Route path="/maintenance" element={<PermissionRoute permKey="maintenance_maintenanceTasks"><ManageMaintenance /></PermissionRoute>} />
        <Route path="/maintenance/add" element={<PermissionRoute permKey="maintenance_maintenanceTasks"><AddMaintenance /></PermissionRoute>} />

        {/* Inventory Management */}
        <Route path="/inventory-category" element={<PermissionRoute permKey="inventory_categories"><ManageInventoryCategory /></PermissionRoute>} />
        <Route path="/inventory-items" element={<PermissionRoute permKey="inventory_items"><ManageInventoryItems /></PermissionRoute>} />
        <Route path="/inventory-adjustments" element={<PermissionRoute permKey="inventory_stockAdjustments"><ManageInventoryAdjustments /></PermissionRoute>} />
        {/* ----PR-------- */}
        <Route path="/inventory-purchase-requests" element={<PermissionRoute permKey="inventory_purchase_requests"><ManagePurchaseRequests /></PermissionRoute>} />
        <Route path="/inventory/pr/create" element={<PermissionRoute permKey="pr_create"><CreatePR /></PermissionRoute>} />
        <Route path="/inventory/pr/:id/items" element={<PermissionRoute permKey="pr_create"><ManagePRItems /></PermissionRoute>} />
        <Route path="/inventory/pr/:id/view" element={<PermissionRoute permKey={["inventory_purchase_requests", "inventory_purchase_requests_approvals"]}><ViewPR /></PermissionRoute>} />
        <Route path="/inventory/pr/approvals" element={<PermissionRoute permKey="inventory_purchase_requests_approvals"><PRApprovals /></PermissionRoute>} />
        <Route path="/inventory-purchase-requests/approvals" element={<PermissionRoute permKey="inventory_purchase_requests_approvals"><PRApprovals /></PermissionRoute>} />
        <Route path="/inventory/pr/approve/:id" element={<PermissionRoute permKey="inventory_purchase_requests_approvals"><PRApprovalDetail /></PermissionRoute>} />

        {/* GRN */}
        <Route path="/grn/list" element={<PermissionRoute permKey="grn_list"><ManageGRN /></PermissionRoute>} />
        <Route path="/grn/create" element={<PermissionRoute permKey="grn_create"><CreateGRN /></PermissionRoute>} />
        <Route path="/grn/receive/:poId" element={<PermissionRoute permKey="grn_create"><ReceiveGRNItems /></PermissionRoute>} />
        <Route path="/grn/:id/view" element={<PermissionRoute permKey="grn_list"><ViewGRN /></PermissionRoute>} />
        <Route path="/grn/approvals" element={<PermissionRoute permKey="grn_approvals"><GRNApprovals /></PermissionRoute>} />
        <Route path="/grn/approve/:id" element={<PermissionRoute permKey="grn_approvals"><GRNApprovalDetail /></PermissionRoute>} />

        {/* Material Requests */}
        <Route path="/inventory/material-request/create" element={<PermissionRoute permKey="material_request_create"><CreateRequest /></PermissionRoute>} />
        <Route path="/inventory/material-request/list" element={<PermissionRoute permKey="material_request_list"><RequestList /></PermissionRoute>} />
        <Route path="/inventory/material-request/approvals" element={<PermissionRoute permKey="material_request_approvals"><RequestApproval /></PermissionRoute>} />
        <Route path="/inventory/material-request/approve/:id" element={<PermissionRoute permKey="material_request_approvals"><RequestApprovalDetail /></PermissionRoute>} />
        <Route path="/inventory/material-request/:id/view" element={<PermissionRoute permKey={["material_request_list", "material_request_view_approvals"]}><ViewRequest /></PermissionRoute>} />
        <Route path="/inventory/material-request/:id/items" element={<PermissionRoute permKey="material_request_create"><ManageRequestItems /></PermissionRoute>} />
        <Route path="/inventory/material-request/accepts" element={<PermissionRoute permKey="material_request_accept"><RequestAcceptList /></PermissionRoute>} />
        <Route path="/inventory/material-request/accept/:id" element={<PermissionRoute permKey="material_request_accept"><RequestAccept /></PermissionRoute>} />

        {/* Inventory Issuing (Material Issue Note) */}
        <Route path="/material-issue-note/prepare" element={<PermissionRoute permKey="material_issue_note_prepare"><PrepareItems /></PermissionRoute>} />
        <Route path="/material-issue-note/list" element={<PermissionRoute permKey="material_issue_note_list"><IssueingList /></PermissionRoute>} />
        <Route path="/material-issue-note/ready" element={<PermissionRoute permKey="material_issue_note_ready"><ReadyItems /></PermissionRoute>} />
        <Route path="/material-issue-note/issue" element={<PermissionRoute permKey="material_issue_note_issue"><IssueItems /></PermissionRoute>} />
        <Route path="/material-issue-note/view/:id" element={<PermissionRoute permKey="material_issue_note_list"><ViewIssueNote /></PermissionRoute>} />

        {/* Expenses */}
        <Route path="/expenses/list" element={<PermissionRoute permKey="expenses_list"><ExpenseList /></PermissionRoute>} />
        <Route path="/expenses/approve" element={<PermissionRoute permKey="expenses_approve"><ApproveExpenses /></PermissionRoute>} />
        <Route path="/expenses/payment/create" element={<PermissionRoute permKey="expenses_payment_create"><CreatePayment /></PermissionRoute>} />
        <Route path="/expenses/payment/settle" element={<PermissionRoute permKey="expenses_payment_settle"><PaymentSettle /></PermissionRoute>} />

        {/* Reports */}
        <Route path="/reports" element={<PermissionRoute permKey={REPORT_PERMISSION_KEYS}><AllReports /></PermissionRoute>} />
        <Route path="/reports/inventory" element={<PermissionRoute permKey="reports_inventory"><InventoryItemsReport /></PermissionRoute>} />
        <Route path="/reports/inventory/stock-adjustments" element={<PermissionRoute permKey="reports_inventory_stockadjustments"><StockAdjustmentsReport /></PermissionRoute>} />
        <Route path="/reports/inventory/purchase-requests" element={<PermissionRoute permKey="reports_inventory_purchase_requests"><PurchaseRequestsReport /></PermissionRoute>} />
        <Route path="/reports/inventory/grn" element={<PermissionRoute permKey="reports_inventory_grn"><GrnReport /></PermissionRoute>} />
        <Route path="/reports/inventory/material-requests" element={<PermissionRoute permKey="reports_inventory_material_requests"><MaterialRequestsReport /></PermissionRoute>} />
        <Route path="/reports/inventory/issue-notes" element={<PermissionRoute permKey="reports_inventory_issue_notes"><IssueNotesReport /></PermissionRoute>} />
        <Route path="/reports/inventory/stock-valuation" element={<PermissionRoute permKey="reports_inventory_stock_valuation"><StockValuationReport /></PermissionRoute>} />
        <Route path="/reports/inventory/low-stock" element={<PermissionRoute permKey="reports_inventory_low_stock"><LowStockReport /></PermissionRoute>} />
        <Route path="/reports/maintenance/tasks" element={<PermissionRoute permKey="reports_maintenance"><MaintenanceTasksReport /></PermissionRoute>} />
        <Route path="/reports/expenses/expenses" element={<PermissionRoute permKey="reports_expenses"><ExpensesReport /></PermissionRoute>} />
        <Route path="/reports/expenses/cash-flow" element={<PermissionRoute permKey="reports_expenses_cash_flow"><CashFlowReport /></PermissionRoute>} />
        <Route path="/reports/expenses/payments" element={<PermissionRoute permKey="reports_expenses_payments"><PaymentsReport /></PermissionRoute>} />
        <Route path="/reports/farm/plants" element={<PermissionRoute permKey="reports_farm_plants"><PlantsReport /></PermissionRoute>} />

        {/* System Visualizer */}
        <Route path="/farmoverview" element={<PermissionRoute permKey="farmSetUp_farmOverview"><SystemVisualizer /></PermissionRoute>} />

        {/* Access Denied */}
        <Route path="/access-denied" element={<AccessDenied />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;